module.exports = __webpack_public_path__ + "static/media/placeholder-ssvm.b344d52f.svg";